// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { FilterX as RawFilterX } from "lucide-react";
export const FilterX = /* @__PURE__ */ createIcon(RawFilterX, "FilterX", 2);
